export default __webpack_public_path__ + "static/media/avatar2.af9e4a32.png";